import { councilDeviceApi } from "@/lib/api"
import { useInfiniteQuery } from "@tanstack/react-query"
import type { DeviceDTO, ApiResponsePaginatedResponseDTODeviceDTO } from "@/gen/api"

type Device = DeviceDTO

const deviceListApi = async (
  councilId: string,
  page: number,
  search?: string,
  status?: string,
  customerId?: number,
  type?: string,
): Promise<{ devices: Device[]; nextPage: number | null }> => {
  const response = await councilDeviceApi.getCouncilDevices(
    councilId,
    search,
    status,
    type,
    customerId?.toString(),
    page,
    10,
  )
  const data = (response.data as ApiResponsePaginatedResponseDTODeviceDTO).data
  return {
    devices: data?.items ?? [],
    nextPage:
      (data?.currentPage ?? -1) < (data?.totalPages ?? 0) - 1 ? (data?.currentPage ?? 0) + 1 : null,
  }
}

export const useGetDevicePage = (
  councilId: string,
  search?: string,
  status?: string,
  customerId?: number,
  type?: string,
) => {
  return useInfiniteQuery<{ devices: Device[]; nextPage: number | null }>({
    queryKey: ["devices", councilId, search, status, customerId, type],
    queryFn: ({ pageParam }) =>
      deviceListApi(councilId, pageParam as number, search, status, customerId, type),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    throwOnError: false,
  })
}
